import { render, staticRenderFns } from "./SVC91000.vue?vue&type=template&id=5643fed5&"
import script from "./SVC91000.vue?vue&type=script&lang=js&"
export * from "./SVC91000.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports